// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_next__PZkYK {
  display: flex;
  align-items: center; }
  .styles_next__PZkYK svg {
    margin-left: 0.75rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Button/NextButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,mBAAmB,EAAA;EAFvB;IAIQ,oBAAoB,EAAA","sourcesContent":[".next {\n    display: flex;\n    align-items: center;\n    & svg {\n        margin-left: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"next": `styles_next__PZkYK`
};
export default ___CSS_LOADER_EXPORT___;
